






































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Button, Dialog, Toast, Popup, List } from 'vant';
import * as config from './config';
import { isWeiXin } from '@/common/ts/common';
import { userList, userDel } from './api';
import ListItem from './components/ListItem.vue';
import { appShare, wxShareInfo } from '@/common/ts/common';
import qs from 'qs';
Vue.use(Popup)
  .use(Dialog)
  .use(Toast)
  .use(Button)
  .use(List);

@Component({
  components: {
    ListItem,
  },
})
export default class User extends Vue {
  option = config.OPTHINES;
  userStatus: any = null;
  showModal = false;
  userList: any[] = [];
  createDate: any[] = [];
  showUser = true;
  showUserList = true;
  pointOut = false;
  loading = false;
  finished = false;
  page = 1;
  unionId!: string | null;
  get source() {
    return this.$route.params.source;
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  confirmWeixin() {
    if (isWeiXin()) {
      if (this.$route.query.source === '5') {
        this.showUser = true;
        if (!window.localStorage.getItem('unionid')) {
          this.$dialog
            .confirm({
              title: '微信登录',
              message: '上传作品前需要进行微信登录',
            })
            .then(() => {
              console.log('确定');
              this.WechatLogin();
            })
            .catch(() => {
              console.log('取消');
            });
          return;
        } else {
          console.log(
            'this.$route.query',
            window.localStorage.getItem('unionid'),
          );
          this.unionId = window.localStorage.getItem('unionid');
        }
      } else {
        this.showUser = false;
      }
    } else {
      this.showUser = false;
      // Dialog.alert({
      //   title: '友情提示',
      //   message:
      //     '请在微信、“重庆发布”、“iChongqing爱重庆”、“光明网重庆频道”、“智慧八方”微信公众号内进行作品上传',
      //   closeOnClickOverlay: true,
      // })
      //   .then(() => {
      //     console.log('then');
      //   })
      //   .catch(() => {
      //     console.log('catch');
      //   });
    }
  }
  created() {
    // 登录成功后回调
    window.userInfoChange = () => {
      this.$router.go(0);
    };
    // 分享
    appShare({
      title:
        '这是我参加第六届“紫荆杯”两岸暨港澳青少年书画大赛的作品，请为我点赞！',
      url: window.location.href,
      subtitle:
        '这是我参加第六届“紫荆杯”两岸暨港澳青少年书画大赛的作品，请为我点赞！',
      classId: -1,
      id: -1,
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    wxShareInfo({
      title:
        '这是我参加第六届“紫荆杯”两岸暨港澳青少年书画大赛的作品，请为我点赞！',
      subtitle:
        '这是我参加第六届“紫荆杯”两岸暨港澳青少年书画大赛的作品，请为我点赞！',
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  onLoad() {
    this.confirmWeixin();
    // if (window.localStorage.getItem('unionid')) {
    userList(this.page, { unionid: this.unionId }).then((res: any) => {
      this.successGetUser(res);
    });
    // }
  }
  public successGetUser(res: any) {
    console.log(res.code);
    switch (res.code) {
      case 500:
        this.showUserList = false;
        // if (!window.udid) {
        //   // if (isWeiXin()) {
        //   Dialog.confirm({
        //     title: '友情提示',
        //     message: '请在上游新闻App进行上传作品',
        //     confirmButtonText: '还没装？一步安装',
        //     cancelButtonText: '我已安装过',
        //     overlay: true,
        //     closeOnClickOverlay: false,
        //   })
        //     .then(() => {
        //       window.location.href =
        //         'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
        //     })
        //     .catch(() => {
        //       if (isWeiXin() === true) {
        //         this.pointOut = true;
        //       } else {
        //         window.location.href =
        //           'shangyounews://{"dt":"7","url":"' +
        //           document.location.href +
        //           '"}';
        //       }
        //     });
        // } else if (parseFloat(window.version) >= 4.5) {
        //   window.handleMessage('{"action":"mUserLogin","data":""}');
        // } else {
        //   window.location.href = 'client:logout';
        // }
        this.confirmWeixin();
        break;
      case 200:
        console.log('res.data', res.data);
        if (this.page === 1 && res.data === '') {
          console.log('没有数据');
          this.showUserList = false;
          this.showUser = true;
        } else {
          console.log('res.data', res.data);
          this.page = this.page + 1;
          if (!res.data || res.data.length === 0) {
            this.finished = true;
          } else {
            this.userList = [...this.userList, ...res.data];
          }
          this.loading = false;
          // 时间格式转换
          for (const timeItem of res.data) {
            const date = new Date();
            date.setTime(timeItem.createtime * 1000);
            // const year = date.getYear();
            const month = date.getMonth() + 1;
            const d = date.getDate();
            this.createDate.push(month + '-' + d);
          }
        }
    }
  }
  public handleDel(i: any) {
    Dialog.confirm({
      title: '提示',
      message: '你确定要删除吗？',
    })
      .then(() => {
        userDel({ id: i, unionid: this.unionId }).then((res) =>
          this.successDelete(res),
        );
      })
      .catch(() => {
        console.log('取消删除');
      });
  }
  // 删除成功
  public successDelete(res: any) {
    if (res.code === 200) {
      Toast('删除成功！');
      setTimeout(() => {
        this.$router.go(0);
      }, 1000);
    }
  }
  public enterUploading() {
    // if (window.gettoken() && window.gettoken() !== 'null') {
    //   setTimeout(() => {
    //     this.$router.push({ path: './Uploading' });
    //   }, 300);
    // } else {
    //   // 用户未登录
    //   if (parseFloat(window.version) >= 4.5) {
    //     const option = {
    //       action: 'mUserLogin',
    //       data: '请先登录上游账号',
    //     };
    //     window.handleMessage(JSON.stringify(option));
    //   } else {
    //     window.location.href = 'client:logout';
    //   }
    // }
    this.confirmWeixin();
    if (
      window.localStorage.getItem('unionid') &&
      this.$route.query.source === '5'
    ) {
      setTimeout(() => {
        this.$router.push({ path: './Uploading' });
      }, 300);
    }
  }
  public toggleDialog() {
    this.showModal = !this.showModal;
  }
}
